/**
 * 迁移账户 — 独立菜单页（整条线迁移 + 系谱图前后对比）
 */
import { useState } from 'react';
import { Alert, Button, Card, Input, Space, Spin, Typography, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { api, ApiError } from '../../api/client';
import { ShiftUplineForm } from '../../components/ShiftUplineModal';
import { useAuthStore } from '../../store/auth';

export function ShiftUplinePage() {
  const hasNode = useAuthStore((s) => s.hasNode);
  const canShift = hasNode('platform.user.shift_upline');
  const [lookupInput, setLookupInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [target, setTarget] = useState<{ id: number; username: string } | null>(null);

  async function lookupUser() {
    const input = lookupInput.trim();
    if (!input) {
      message.warning('请输入用户名、用户ID或编号');
      return;
    }
    const query = /^\d+$/.test(input) ? { id: Number(input) } : { username: input };
    setLoading(true);
    try {
      const user = await api.get<{ id: number; username: string }>(
        '/api/admin/users/lookup',
        query,
      );
      setTarget(user);
    } catch (e) {
      message.error(e instanceof ApiError ? e.message : '用户未找到');
      setTarget(null);
    } finally {
      setLoading(false);
    }
  }

  if (!canShift) {
    return (
      <Alert
        type="error"
        showIcon
        message="无权限"
        description="需要 platform.user.shift_upline 节点权限。"
      />
    );
  }

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>迁移账户</h2>
      <Typography.Paragraph type="secondary">
        将主号及其整条推荐线（含子账户）平移到新上级；预览迁移前后系谱图与全部旗下账户列表。
      </Typography.Paragraph>

      <Card style={{ marginBottom: 16, maxWidth: 520 }}>
        <Space.Compact style={{ width: '100%' }}>
          <Input
            placeholder="待迁移用户名、用户ID或编号（如106060）"
            value={lookupInput}
            onChange={(e) => setLookupInput(e.target.value)}
            onPressEnter={() => void lookupUser()}
            disabled={loading}
          />
          <Button type="primary" icon={<SearchOutlined />} loading={loading} onClick={() => void lookupUser()}>
            查找
          </Button>
        </Space.Compact>
      </Card>

      {loading && (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      )}

      {!loading && target && (
        <Card title={`迁移预览 · #${target.id} ${target.username}`}>
          <ShiftUplineForm
            userId={target.id}
            username={target.username}
            onDone={() => {
              message.success('迁移已完成');
              setTarget(null);
              setLookupInput('');
            }}
          />
        </Card>
      )}
    </div>
  );
}
